import { required } from '@vuelidate/validators'

export const SignInValidation = {
    login: { required },
    password: { required },
}
